import { render, staticRenderFns } from "./Unificacoes.vue?vue&type=template&id=54255f2e"
import script from "./Unificacoes.vue?vue&type=script&lang=js"
export * from "./Unificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports